import { AUTH_TOKEN, API_URL, REFRESH_TOKEN } from "./config"

const defaultHeaders = {
  Accept: "application/json; version=1.0",
  Origin: "https://fms.noa.one",
  "Content-Type": "application/json",
}

export const fetcher = async (url: string, options?: RequestInit) => {
  const token = localStorage.getItem(AUTH_TOKEN)

  const headers: any = options?.headers || { ...defaultHeaders }
  if (token) {
    headers.Authorization = "JWT " + token
  }
  const fullUrl = API_URL + url
  try {
    const res = await fetch(fullUrl, { ...options, headers })
    if (res.status === 401) {
      const newPayload = await refetchToken()
      if (newPayload.token) {
        headers.Authorization = "JWT " + newPayload.token
        return fetch(fullUrl, { ...options, headers }).then((res) => res.json())
      }
    }
    if (res.status === 204) return
    return await res.json()
  } catch (e) {
    console.error("Fetch error:", e)
    return
  }
}

interface RefreshPayload {
  token: string
  refresh_token: string
}

export const refetchToken = async () => {
  const fullUrl = API_URL + "jwt/refresh_token/"
  const refresh_token = localStorage.getItem(REFRESH_TOKEN)
  try {
    const headers = { ...defaultHeaders }
    const refresh: RefreshPayload = await fetch(fullUrl, {
      body: JSON.stringify({ refresh_token, client_id: "local" }),
      method: "post",
      headers,
    }).then((res) => res.json())
    if (refresh.token) {
      localStorage.setItem(AUTH_TOKEN, refresh.token)
      localStorage.setItem(REFRESH_TOKEN, refresh.refresh_token)
      return refresh
    } else {
      logout()
      return refresh
    }
  } catch (e) {
    logout()
    throw e
  }
}

const logout = () => {
  localStorage.removeItem(AUTH_TOKEN)
  localStorage.removeItem(REFRESH_TOKEN)
}
